import React from 'react';

import { InputTextarea as InputTextareaPrime } from 'primereact/inputtextarea';

const InputTextArea: React.FC<
  React.ComponentPropsWithoutRef<typeof InputTextareaPrime> & {
    id?: string;
    name?: string;
    className?: string;
    autoResize?: boolean;
  }
> = (props) => {
  return (
    <InputTextareaPrime
      {...props}
      name={props.name || props.id}
      className={`${props.className || ''}`}
      autoResize={props.autoResize || true}
    />
  );
};

export default InputTextArea;
